import React from 'react';
import Navigation from '../Navigation/Navigation';
import Logo from './Logo';
import VintageBadge from './VintageBadge';
import HeaderBackground from './HeaderBackground';
import { useScrollBehavior } from '../../hooks/useScrollBehavior';

export default function Header() {
  const { scrollProgress } = useScrollBehavior(100);

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50">
        <HeaderBackground scrollProgress={scrollProgress} />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-24">
            <div className="flex items-center space-x-4">
              <Logo />
              <VintageBadge scrollProgress={scrollProgress} />
            </div>
            <Navigation scrollProgress={scrollProgress} />
          </div>
        </div>
      </header>
      {/* Spacer to prevent content from jumping when header becomes fixed */}
      <div className="h-24" aria-hidden="true" />
    </>
  );
}